export enum NotificationTypes {
    campaign = 'campaign',
    comment = 'comment',
    points = 'points',
    like = 'like',
    favorite = 'favorite',
    postLike = 'postLike',
    gembaLike = 'gembaLike'
}